import React from 'react';
import { UserSummaryDto } from '../models/user';
import { Avatar } from './user/avatar/Avatar';

export const UserAvatar: React.FC<{ user: UserSummaryDto }> = ({ user }) => (
  <Avatar azureId={user.azureUserId} name={user.name} size="small" />
);
